<template>
  <breadCrumbs title="Wow Animation" main="Animation" title1="Wow Animation" />
    <div class="card">
               <div class="card-header pb-0">
                 <h3>WOW Example animation</h3>
               </div>
                <div class="card-body">
                 <div v-masonry class="row gallery grid my-gallery" id="aniimated-thumbnials">
                   <figure  v-masonry-tile  class="grid-item col-sm-4 col-md-3" v-for="(src, index) in imgs" :key="index" @click="() => showImg(index)" >
                        <aos-vue :animation="src.animation">
                       <a>
                       <img :src="require('../../../assets/images/masonry/'+src.image)" alt="Image description" class="img-thumbnail" />
                       </a>
                       </aos-vue>
                   
                   </figure>
                 </div>
                <vue-easy-lightbox
                 :visible="visible"
                 :index="index"
                 :imgs="lightBoxImages" 
                 @hide="handleHide">
                </vue-easy-lightbox>
               </div>
    </div>
</template>
<script>
export default {
 data(){
     return{
         lightBoxImages:[],
         lightBoxTitle:[],
         visible: false,
       imgs: [
      { image:'1.jpg', animation:"fade-down"},
       {image:'2.jpg', animation:"zoom-out-down"},
       { image:'3.jpg', animation:"flip-down"},
       {image:'4.jpg',animation:"fade-up" },
       {image:'5.jpg',animation:"flip-down" },
       { image:'6.jpg', animation:"fade-up" },
       { image:'7.jpg', animation:"flip-down" },
       { image:'8.jpg', animation:"fade-up"},
       { image:'9.jpg', animation:"flip-down" },
       { image:'10.jpg', animation:"fade-up" },
       { image:'11.jpg', animation:"flip-down" },
       { image:'12.jpg', animation:"fade-up" },
       { image:'14.jpg', animation:"flip-down" },
       { image:'15.jpg', animation:"flip-left" },
       { image:'13.jpg', animation:"flip-down" },
        { image:'4.jpg', animation:"zoom-out" },
        { image:'5.jpg', animation:"flip-right" },
        { image:'6.jpg', animation:"zoom-out" },
        { image:'7.jpg', animation:"zoom-out-up" },
        { image:'8.jpg', animation:"zoom-out-down" },
        { image:'9.jpg', animation:"flip-down" },
        { image:'10.jpg', animation:"slide-up" },
        { image:'9.jpg', animation:"flip-down" },
        { image:'10.jpg', animation:"fade-up" },
        { image:'11.jpg', animation:"flip-down" },
        { image:'12.jpg', animation:"fade-up" },
        { image:'14.jpg', animation:"flip-down" },
        { image:'15.jpg', animation:"flip-left" },
        { image:'13.jpg', animation:"flip-down" },
        { image:'4.jpg', animation:"zoom-out" },
        { image:'5.jpg', animation:"flip-right" },
        { image:'6.jpg', animation:"zoom-out" },
        { image:'7.jpg', animation:"zoom-out-up" }
   ]
     }
 },
  methods: {
   showImg (index) {
     this.index = index
     this.visible = true
   },
   handleHide () {
     this.visible = false
   },
 },
 mounted(){
     this.imgs.forEach(item=>{
         this.lightBoxImages.push(require('@/assets/images/masonry/'+item.image))
         this.lightBoxTitle.push(item.title)
     })
 }
};
</script>